import { Filter } from '@cubejs-client/core';

import { DimPurchaseOrderItemField } from '~/common/types/cubes/DimPurchaseOrderItem';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { PurchaseOrderCountWidget } from './PurchaseOrderCountWidget';

export const CommodityGroupPurchaseOrderCountWidget = () => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimPurchaseOrderItemField.COMMODITY_GROUP_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <PurchaseOrderCountWidget filters={filters} />;
};
